module.exports = __webpack_public_path__ + "img/window&curtain.114bf002.png";